import React from 'react';

export function Badge({ children, color = "#6b7280" }) {
  return (
    <span style={{ 
      display: "inline-block", 
      padding: "2px 10px", 
      borderRadius: 999, 
      fontSize: 11, 
      fontWeight: 700,
      letterSpacing: "0.04em", 
      background: color + "18", 
      color, 
      textTransform: "uppercase" 
    }}>
      {children}
    </span>
  );
}

export default Badge;
